// extracted by mini-css-extract-plugin
module.exports = {"info":"_1aWQ3_H9Rdj3","segments":"yew25N2qCLb_","footer":"_3zhpxPoUFckk","button_default":"_3-Ok1RPa40Ha","button":"_3oF0R6HGYoqJ"};